// src/components/ModalShell.jsx
import React from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";

export default function ModalShell({ isOpen, onClose, title, children }) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      role="dialog"
      contentLabel={typeof title === "string" ? title : "modal"}
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          width: 840,
          maxWidth: "95vw",
          padding: 24,
          borderRadius: 12,
          border: "1px solid #eee",
          fontFamily: "Inter, sans-serif",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,.45)",
          zIndex: 1008,
        },
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h3 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>{title}</h3>

        <button
          type="button"
          onClick={onClose}
          className="btn-secondary"
          aria-label={t("actions.close", "Cerrar")}
          title={t("actions.close", "Cerrar")}
          style={{ padding: "6px 12px", borderRadius: 10 }}
        >
          {t("actions.close", "Cerrar")}
        </button>
      </div>

      <div>{children}</div>
    </Modal>
  );
}
